import { Component, OnInit } from '@angular/core';
import { PopupService } from '../../services/popup.service';
import { environment } from '../../../environments/environment';
import { UserService } from '../../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.less']
})
export class PopupComponent implements OnInit {
  sigupSigninOptions: any = {
    AUTH_URL: environment.APP.AUTH_URL,
    environmentName: environment.name,
    JLL_DOMAIN: environment.APP.JLL.HOSTNAME
  }
  constructor(public popupService: PopupService, 
    public userService: UserService, 
    public activatedRoute: ActivatedRoute, 
    public router: Router) { }

  ngOnInit() {
    if(this.router.url.includes('open')) {
      let popup = this.activatedRoute.snapshot.params.popup;
      let inner = this.activatedRoute.firstChild && this.activatedRoute.firstChild.snapshot.params.inner;
      let subInner = this.activatedRoute.firstChild && this.activatedRoute.firstChild.firstChild && this.activatedRoute.snapshot.params.subInner;

      this.router.navigate(['/map/'+((popup)?(popup+((inner)? ('/'+inner+((subInner)? ('/'+subInner):'')):'')):'')],{
        queryParams: this.activatedRoute.snapshot.queryParams
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/popup/popup.component.ts